import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "highlightsearch",
    standalone: false
})
export class HighlightSearchPipe implements PipeTransform {
  transform(value: string | undefined, args: any): any {
    if (!args) {
      return value;
    }

    if (!value || typeof value !== "string") {
      return value;
    }

    const re = new RegExp(args, "gi"); // 'gi' for case insensitive
    return value.toString().replace(re, "<mark>$&</mark>");
  }
}
